import React, { useCallback, useState } from 'react';
import IconMC from '../../../../components/IconMC';
import PreviewPdfInstruction from '../Guides/PreviewPdfInstruction';

/**
 * Tries Guides' PreviewPdfInstruction (pdfjs first page).
 * Falls back to document icon on CORS / load failure.
 */
const PdfPreviewOrIcon = ({
  src,
  iconClassName = 'tw-text-blue-500',
  wrapperClassName = 'tw-w-10 tw-h-10 tw-rounded-lg tw-overflow-hidden tw-bg-gray-100 tw-border tw-border-gray-200 tw-shrink-0',
  iconWrapperClassName = 'tw-w-10 tw-h-10 tw-rounded-lg tw-bg-blue-50 tw-flex tw-items-center tw-justify-center tw-shrink-0'
}) => {
  const [failed, setFailed] = useState(false);
  const handleError = useCallback(() => setFailed(true), []);

  if (!src || failed) {
    return (
      <div className={iconWrapperClassName}>
        <IconMC name="new-document" className={iconClassName} />
      </div>
    );
  }

  return (
    <div className={wrapperClassName}>
      <PreviewPdfInstruction loadedFile={src} onError={handleError} />
    </div>
  );
};

export default PdfPreviewOrIcon;
